(() => {
  if (window.__merlonsHomeAboutVideoBound) return;
  window.__merlonsHomeAboutVideoBound = true;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-merlons-about-video][data-video-id]');
    if (!button) return;

    const videoId = button.dataset.videoId;
    if (!videoId) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'merlons-home-about__player';
    iframe.title = button.dataset.videoTitle || button.getAttribute('aria-label') || 'Merlons branch video';
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?rel=0&modestbranding=1&playsinline=1&autoplay=1`;
    iframe.loading = 'eager';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    iframe.tabIndex = 0;

    button.replaceWith(iframe);
    window.setTimeout(() => iframe.focus(), 0);
  });
})();
